export default "__VITE_ASSET__00a402b3__"